const _excluded = ["visibleButtons", "extraButtons", "defaultVisibleButtons", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { LocatorInput } from "./input-locator-input.component";
import { LocatorExtraButton, LocatorSearchButton } from "./input-locator-buttons.component";
import { LocatorModal } from "./input-locator-modal.component";
import { locatorDefaultVisibleButtons } from "./input-locator.constants";
import { useUrlResolverLocatorDetailQuery, useGenericObjectReadQueryPromise } from '@isyc-react/oc-api';
import { nanoid } from 'nanoid';
import '@isyc-react/design/main';
import "./input-locator.style.scss";
import { useFormCommonProps } from "../../context";
// urlLocator example: /newspring/modules/core/personLocator
// urlDetail example: /newspring/modules/core/person
/**
 * if objectTypeId can change, autocomplete -> cacheOptions should be false
 * */
export const InputLocator = props => {
  var _value$value3, _value$id2;
  const _useFormCommonProps = useFormCommonProps(props),
    {
      visibleButtons,
      extraButtons,
      defaultVisibleButtons = true,
      children
    } = _useFormCommonProps,
    common = _objectWithoutProperties(_useFormCommonProps, _excluded);
  const {
    onChange,
    onBlur,
    value,
    error,
    size,
    readOnly,
    disabled,
    autocomplete,
    objectTypeId,
    businessUnitId
  } = common;
  const {
    data,
    error: errorUrls,
    loading: loadingUrls
  } = useUrlResolverLocatorDetailQuery({
    variables: {
      objectTypeId
    }
  });
  const getGenericObject = useGenericObjectReadQueryPromise();
  const urlLocator = React.useMemo(() => data && data.urlResolver_locator_detail && data.urlResolver_locator_detail.urlLocator ? `${data.urlResolver_locator_detail.urlLocator.startsWith('/') ? '' : '/'}${data.urlResolver_locator_detail.urlLocator}` : null, [data]);
  const urlDetail = React.useMemo(() => data && data.urlResolver_locator_detail && data.urlResolver_locator_detail.urlDetail ? `${data.urlResolver_locator_detail.urlDetail.startsWith('/') ? '' : '/'}${data.urlResolver_locator_detail.urlDetail}` : null, [data]);
  const [modal, setModal] = React.useState(false);
  const targetId = React.useMemo(() => nanoid(12), []);
  const refId = React.useRef(null);
  const refValue = React.useRef(null);
  const refRole = React.useRef(null);
  const refActive = React.useRef();
  const refLocatorInput = React.useRef(null);

  // TODO delete when there is no more CORE dirtySpring dependency
  // This event dispatch just activate the save button on OC forms
  const onAutocompleteSelected = selected => {
    if (selected && (value === null || value === void 0 ? void 0 : value.id) !== selected.value && refValue.current) {
      refValue.current.dispatchEvent(new CustomEvent('change'));
    }
  };
  const focus = () => {
    if (refLocatorInput && refLocatorInput.current) refLocatorInput.current.focus();
  };
  const blur = () => {
    focus();
    if (refLocatorInput && refLocatorInput.current) refLocatorInput.current.blur();
  };
  React.useEffect(() => {
    var _refId$current, _refValue$current, _value$role, _value$value2;
    if (((_refId$current = refId.current) === null || _refId$current === void 0 ? void 0 : _refId$current.value) != (value === null || value === void 0 ? void 0 : value.id)) {
      var _value$id;
      if (value !== null && value !== void 0 && value.id && ((value === null || value === void 0 ? void 0 : value.value) == undefined || (value === null || value === void 0 ? void 0 : value.active) == undefined)) {
        getGenericObject({
          objectTypeId: objectTypeId,
          objectId: parseInt(value === null || value === void 0 ? void 0 : value.id)
        }).then(response => {
          var _refId$current2;
          if (((_refId$current2 = refId.current) === null || _refId$current2 === void 0 ? void 0 : _refId$current2.value) == value.id) {
            var _refRole$current, _value$value, _value$active;
            refActive && (refActive.current = response.data.genericObject_read.activeFlag);
            onChange && onChange({
              id: refId.current.value,
              role: (_refRole$current = refRole.current) === null || _refRole$current === void 0 ? void 0 : _refRole$current.value,
              value: (_value$value = value === null || value === void 0 ? void 0 : value.value) !== null && _value$value !== void 0 ? _value$value : response.data.genericObject_read.name,
              active: (_value$active = value === null || value === void 0 ? void 0 : value.active) !== null && _value$active !== void 0 ? _value$active : response.data.genericObject_read.activeFlag
            });
          }
        });
      }
      refId.current && (refId.current.value = (_value$id = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id !== void 0 ? _value$id : '');
    } else if (value !== null && value !== void 0 && value.id && (value === null || value === void 0 ? void 0 : value.value) == undefined && refValue !== null && refValue !== void 0 && (_refValue$current = refValue.current) !== null && _refValue$current !== void 0 && _refValue$current.value) {
      var _refRole$current2, _refValue$current2;
      onChange && onChange({
        id: value.id,
        role: (_refRole$current2 = refRole.current) === null || _refRole$current2 === void 0 ? void 0 : _refRole$current2.value,
        value: (_refValue$current2 = refValue.current) === null || _refValue$current2 === void 0 ? void 0 : _refValue$current2.value,
        active: refActive.current
      });
    }
    refRole.current && (refRole.current.value = (_value$role = value === null || value === void 0 ? void 0 : value.role) !== null && _value$role !== void 0 ? _value$role : '');
    refValue.current && (refValue.current.value = (_value$value2 = value === null || value === void 0 ? void 0 : value.value) !== null && _value$value2 !== void 0 ? _value$value2 : '');
    refActive.current && (refActive.current = value === null || value === void 0 ? void 0 : value.active);
  }, [value]);
  React.useEffect(() => {
    if (refId.current) {
      refId.current.onchange = () => {
        var _refId$current$value, _refId$current3, _refValue$current$val, _refValue$current3, _refRole$current3;
        const currentData = {
          id: (_refId$current$value = (_refId$current3 = refId.current) === null || _refId$current3 === void 0 ? void 0 : _refId$current3.value) !== null && _refId$current$value !== void 0 ? _refId$current$value : '',
          value: (_refValue$current$val = (_refValue$current3 = refValue.current) === null || _refValue$current3 === void 0 ? void 0 : _refValue$current3.value) !== null && _refValue$current$val !== void 0 ? _refValue$current$val : '',
          role: (_refRole$current3 = refRole.current) === null || _refRole$current3 === void 0 ? void 0 : _refRole$current3.value,
          active: true
        };
        setModal(false);
        onChange && onChange(currentData);
        focus();
        // blur() // TODO si o no blur al elegir uno en el locator?
      };
    }
  }, [onChange, onBlur]);
  const utils = {
    modal,
    setModal,
    blur,
    focus,
    urlDetail,
    urlLocator,
    errorUrls: Boolean(errorUrls),
    loadingUrls
  };
  const LocatorButtonRenderer = ({
    button: LocatorButton,
    children
  }) => /*#__PURE__*/React.createElement(LocatorButton, _extends({}, common, utils), children);
  const LocatorButtonsRenderer = ({
    buttons
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, buttons.map((ButtonComponent, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'ms-2'
  }, /*#__PURE__*/React.createElement(LocatorButtonRenderer, {
    button: ButtonComponent
  }))));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "input-locator-container"
  }, /*#__PURE__*/React.createElement(LocatorInput, {
    ref: refLocatorInput,
    error: error,
    size: size,
    objectTypeId: objectTypeId,
    businessUnitId: businessUnitId,
    autocomplete: autocomplete,
    value: value ? {
      label: (_value$value3 = value.value) !== null && _value$value3 !== void 0 ? _value$value3 : '',
      value: (_value$id2 = value.id) !== null && _value$id2 !== void 0 ? _value$id2 : ''
    } : null,
    onChange: selected => {
      onAutocompleteSelected(selected);
      onChange && onChange(selected ? {
        value: selected.label,
        id: selected.value,
        active: true
      } : null);
    },
    modal: modal,
    setModal: setModal,
    readOnly: readOnly,
    disabled: disabled,
    onFocus: onBlur,
    onBlur: onBlur,
    prefix: () => /*#__PURE__*/React.createElement(LocatorButtonRenderer, {
      button: LocatorSearchButton
    }),
    suffix: () => /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center"
    }, defaultVisibleButtons && /*#__PURE__*/React.createElement(LocatorButtonsRenderer, {
      buttons: locatorDefaultVisibleButtons
    }), visibleButtons && visibleButtons.length > 0 && /*#__PURE__*/React.createElement(LocatorButtonsRenderer, {
      buttons: visibleButtons
    }), extraButtons && extraButtons.length > 0 && /*#__PURE__*/React.createElement(LocatorExtraButton, _extends({
      items: extraButtons
    }, common, utils), item => /*#__PURE__*/React.createElement(LocatorButtonRenderer, {
      button: item
    })))
  })), /*#__PURE__*/React.createElement(LocatorModal, _extends({}, common, utils), /*#__PURE__*/React.createElement("iframe", {
    className: "input-locator-iframe",
    title: "objectLocator",
    src: encodeURI(`${urlLocator}?targetElement=${targetId}&doSubmit=false&action=popUpLoc&businessUnitId=${businessUnitId !== null && businessUnitId !== void 0 ? businessUnitId : ''}`)
  })), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    ref: refId,
    id: `${targetId}_id`
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    ref: refRole,
    id: `${targetId}_role`
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    ref: refValue,
    id: `${targetId}_value`
  }));
};